import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-navy shadow-lg' : 'bg-navy/95 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-orange rounded-lg flex items-center justify-center">
                  <i className="ri-delete-bin-line text-white text-xl"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-white font-bold text-lg leading-tight">BIOTRAUMA</span>
                  <span className="text-orange text-xs font-semibold leading-tight">BARCELONA</span>
                </div>
              </div>
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-orange'
                      : 'text-white hover:text-orange'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+34629501941"
                className="bg-orange text-white px-6 py-2.5 rounded-full font-medium hover:bg-orange-light transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                629 501 941
              </a>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-white text-2xl cursor-pointer"
              aria-label="Menú"
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-navy border-t border-white/10"
          >
            <div className="px-4 py-4 space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block py-2 text-sm font-medium ${
                    location.pathname === link.path ? 'text-orange' : 'text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+34629501941"
                className="block bg-orange text-white px-6 py-3 rounded-full font-medium text-center cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                629 501 941
              </a>
            </div>
          </motion.div>
        )}
      </motion.nav>

      <a
        href="https://wa.me/34629501941"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white text-3xl shadow-lg hover:scale-110 transition-transform cursor-pointer will-change-transform"
        style={{ animation: 'pulse 2s infinite' }}
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line"></i>
      </a>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </>
  );
};

export default Navbar;
